// extracted by mini-css-extract-plugin
export default {"mCard":"fB-z","image":"gB-z","imageNoBackground":"hB-z","imageHasCategory":"iB-z","fullWidth":"jB-z"};